import type { FilterModelValue } from '@tractian/ui-filters'

import { DateService } from '@/services/date/DateService'

export type DateRangeFilter = {
  from?: string
  to?: string
} & { customFields?: FilterModelValue }

export type AssessmentDateRangeWireParams = {
  assessedFrom?: string
  assessedTo?: string
  updatedFrom?: string
  updatedTo?: string
  completedFrom?: string
  completedTo?: string
}

export type AssessmentDateRangeFilters = {
  startedAt?: DateRangeFilter
  lastUpdatedAt?: DateRangeFilter
  finishedAt?: DateRangeFilter
}

const RANGE_TO_WIRE: Record<
  keyof AssessmentDateRangeFilters,
  { from: keyof AssessmentDateRangeWireParams; to: keyof AssessmentDateRangeWireParams }
> = {
  startedAt: { from: 'assessedFrom', to: 'assessedTo' },
  lastUpdatedAt: { from: 'updatedFrom', to: 'updatedTo' },
  finishedAt: { from: 'completedFrom', to: 'completedTo' }
}

export function buildAssessmentDateRangeParams(
  filters: AssessmentDateRangeFilters
): AssessmentDateRangeWireParams {
  const params: AssessmentDateRangeWireParams = {}

  for (const [rangeKey, wire] of Object.entries(RANGE_TO_WIRE) as [
    keyof AssessmentDateRangeFilters,
    (typeof RANGE_TO_WIRE)[keyof AssessmentDateRangeFilters]
  ][]) {
    const range = filters[rangeKey]
    const from = range?.from ? DateService.dayBoundary(range.from, 'start') : undefined
    const to = range?.to ? DateService.dayBoundary(range.to, 'end') : undefined
    if (from !== undefined) params[wire.from] = from
    if (to !== undefined) params[wire.to] = to
  }

  return params
}
